import {
  REQUEST_DIRECT_AFFILIATION_SEARCH,
  RESPONSE_DIRECT_AFFILIATION_SEARCH,
  FAILURE_DIRECT_AFFILIATION_SEARCH,
  RESPONSE_DIRECT_AFFILIATION_SEARCH_TERMS,
  RESPONSE_DIRECT_AFFILIATION_SEARCH_TWEETS,
  RESPONSE_DIRECT_AFFILIATION_SEARCH_ORGS
} from "../../actions/types";

const initialState = {
  isInitialScreen: true,
  isFetching: false,
  results: [],
  error: false,
  activePage: 1,
  size: 10,
  total: 0,
  relatedTerms: {
    close: [],
    distant: []
  },
  orgs: [],
  tweets: [],
  filters: {
    year: "",
    country: [],
    partner: "false"
  },
  keyword: "",
  totalArticles: 0,
  totalAffiliations: 0
};

const setRequest = (state, action) => {
  let  { keyword, filters, activePage } = action.payload;
  if(!filters){
      filters =  {
        year: "",
        country: [],
        partner: "false"

      }
  }
  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    results: [],
    keyword: keyword,
    filters,
    relatedTerms: {
      close: [],
      distant: []
    },
    orgs: [],
    tweets: [],
    activePage,
    totalArticles: 0,
    totalAffiliations: 0
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    results: [],
    relatedTerms: {
      close: [],
      distant: []
    },
    orgs: [],
    tweets: []
  };
};

const setResponse = (state, action) => {
  let { results = [], totalArticles, totalAffiliations } = action.payload;
  return {
    ...state,
    isFetching: false,
    error: false,
    results: results,
    isInitialScreen: false,
    totalArticles,
    totalAffiliations  };
};

const setResponseTerms = (state, action) => {
  let relatedTerms = action.payload || {};
  let newRelatedTerms = {
    close: relatedTerms.close || [],
    distant: relatedTerms.distant || []
  };
  return {
    ...state,
    relatedTerms: newRelatedTerms
  };
};

const setResponseTweets = (state, action) => {
  let { tweets = [] } = action.payload;
  return {
    ...state,
    tweets: tweets
  };
};

const setResponseOrgs = (state, action) => {
  let { orgs = [] } = action.payload;
  return {
    ...state,
    orgs: orgs
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_DIRECT_AFFILIATION_SEARCH:
      return setResponse(state, action);
      break;

    case FAILURE_DIRECT_AFFILIATION_SEARCH:
      return setFailure(state, action);
      break;

    case REQUEST_DIRECT_AFFILIATION_SEARCH:
      return setRequest(state, action);

    case RESPONSE_DIRECT_AFFILIATION_SEARCH_TERMS:
      return setResponseTerms(state, action);
      break;

    case RESPONSE_DIRECT_AFFILIATION_SEARCH_TWEETS:
      return setResponseTweets(state, action);
      break;

    case RESPONSE_DIRECT_AFFILIATION_SEARCH_ORGS:
      return setResponseOrgs(state, action);
      break;

    default:
      return state;
      break;
  }
};
